import { ResourcefulReducer } from '../../util';
import RelationshipModel from '../models/relationship_model';

const UserRelationshipReducer = new ResourcefulReducer('user_relationships', RelationshipModel, {});

export default UserRelationshipReducer;
